import { useEffect } from 'react'
import { useCartStore, hydrateCartFromServer } from '@/stores/cartStore'

export function useCartHydration() {
  const hydrated = useCartStore((s) => s.hydrated)

  useEffect(() => {
    if (hydrated) return
    hydrateCartFromServer()
  }, [hydrated])

  // The cart is stored server-side and keyed by account, so another client (the
  // mobile app) can change it while this tab sits in the background. Re-read when
  // the tab regains focus. Without this the page keeps rendering a stale cart, and
  // the next write would POST the full array and drop whatever the mobile app added.
  useEffect(() => {
    let inFlight = false

    const refresh = () => {
      if (inFlight || document.visibilityState !== 'visible') return
      inFlight = true
      hydrateCartFromServer().finally(() => {
        inFlight = false
      })
    }

    document.addEventListener('visibilitychange', refresh)
    window.addEventListener('focus', refresh)
    return () => {
      document.removeEventListener('visibilitychange', refresh)
      window.removeEventListener('focus', refresh)
    }
  }, [])
}
